var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-card",
    { staticClass: "bg-grey-2" },
    [
      _c("q-card-title", [
        _vm._v("\n    " + _vm._s(_vm.template.name) + "\n  ")
      ]),
      _c("q-card-separator"),
      _c(
        "q-card-main",
        {
          staticClass: "bg-grey-1 scroll",
          staticStyle: { "max-height": "200px" }
        },
        [_c("div", { domProps: { innerHTML: _vm._s(_vm.template.content) } })]
      ),
      _c("q-card-separator"),
      _c(
        "q-card-actions",
        { staticClass: "bg-grey-1 justify-between" },
        [
          _c(
            "div",
            [
              _c("q-btn", {
                attrs: { label: _vm.$t("edit"), flat: "" },
                on: {
                  click: function($event) {
                    _vm.$emit("edit")
                  }
                }
              }),
              _c("q-btn", {
                attrs: { label: _vm.$t("delete"), flat: "" },
                on: {
                  click: function($event) {
                    _vm.$emit("delete")
                  }
                }
              })
            ],
            1
          ),
          _c("q-btn", {
            attrs: { label: _vm.$t("apply"), color: "primary", flat: "" },
            on: {
              click: function($event) {
                _vm.$emit("apply", _vm.template.content)
              }
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }